import { Link } from "react-router-dom";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";

export function CTASection() {
  return (
    <section className="py-12 lg:py-20 bg-brand-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
          Ready to talk about your training?
        </h2>
        <p className="text-xl text-brand-100 mb-10 max-w-2xl mx-auto">
          Your AI running coach is waiting. Connect your data and start asking
          questions - no more guessing, just answers.
        </p>
        <Link
          to="/register"
          className="inline-flex items-center justify-center gap-2 bg-white text-brand-600 px-8 py-4 rounded-lg font-semibold hover:bg-brand-50 transition-colors shadow-lg"
        >
          Get Started Free
          <ArrowRightIcon className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
